import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-776134de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { CSSProperties, ref } from 'vue';
import { ColumnInterface, TableSortType } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableHeader',
  props: {
    column: {},
    idx: {},
    sortBy: {}
  },
  emits: ["clickHeader", "resizeColumn", "moveFrom", "moveTo", "swapCols"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const tableHeader = ref<HTMLTableCellElement | null>(null);
const isDragging = ref<boolean>(false);

const getSortArrowStyle = (column: ColumnInterface): CSSProperties => {
	if (props.sortBy?.column === column.id) {
		return {
			transform: props.sortBy?.direction === 'desc' ? 'rotate(0)' : 'rotate(180deg)',
			opacity: 1,
		};
	}
	return { transform: 'rotate(0)', opacity: 0.4 };
};

const onDrop = () => {
	emit('swapCols');
	isDragging.value = false;
	tableHeader.value?.classList.remove('table-header__over');
	return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("th", {
    ref_key: "tableHeader",
    ref: tableHeader,
    scope: "col",
    class: "table-header"
  }, [
    _createElementVNode("div", {
      "data-ts": "drag-area",
      draggable: "true",
      onDragstart: _cache[2] || (_cache[2] = ($event: any) => {
				isDragging.value = true;
				_ctx.$emit('moveFrom', props.idx);
			}),
      onDragend: _cache[3] || (_cache[3] = ($event: any) => {
				isDragging.value = false;
				_ctx.$emit('moveTo', null);
			}),
      onDragenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('moveTo', props.idx))),
      onDragover: _withModifiers(() => false, ["prevent"]),
      onDrop: _withModifiers(onDrop, ["stop"])
    }, [
      _createTextVNode(_toDisplayString(_ctx.column.label) + " ", 1),
      (_ctx.column.sortable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            "aria-label": "Sort",
            type: "button",
            tabindex: "0",
            "data-ts": "sort-column-btn",
            class: "table-header__sort-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickHeader', _ctx.column))),
            onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('clickHeader', _ctx.column)), ["enter"]))
          }, [
            (_openBlock(), _createElementBlock("svg", {
              viewBox: "0 0 24 24",
              width: "12px",
              height: "12px",
              fill: "#656565",
              style: _normalizeStyle(getSortArrowStyle(_ctx.column))
            }, _hoisted_2, 4))
          ], 32))
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.column.resizable && !isDragging.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "data-ts": "resizer",
          class: "resizer",
          onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('resizeColumn', $event)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 512))
}
}

})